var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pie-chart',{attrs:{"chartId":"ticket-chart","chartData":_vm.chartData,"colors":_vm.chartColorFunc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }